import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { MerchantKycStatuses, PayoutDestinationType, PayoutDestinations } from 'services/merchants/types';

import { ReduxToolkitError, SuccessResponse } from 'types/http';

import { ALLOWED_KYC_STATUSES } from './keys';
import { PayoutDestinationsDataRow } from './types';

export interface DeleteEntityProps<TParams extends any[] = any[]> {
  isDeleting: boolean;
  deleteError?: ReduxToolkitError | Error | FetchBaseQueryError | SerializedError;
  deleteEntity: (...params: TParams) => Promise<ReduxToolkitError | SuccessResponse>;
  resetDelete: () => void;
}

export const transformPayoutDestinationsListDataToTableFormat = (
  deletePaymentDestinationProps: DeleteEntityProps<[string, PayoutDestinationType]>,
  payoutDestinations?: PayoutDestinations[],
): PayoutDestinationsDataRow[] => {
  return payoutDestinations
    ? payoutDestinations.map((payoutDestination) => ({
        ...payoutDestination,
        id: payoutDestination.uuid,
        type: payoutDestination.type,
        deletePaymentDestinationProps: {
          isDeleting: deletePaymentDestinationProps.isDeleting,
          deleteError: deletePaymentDestinationProps.deleteError,
          deleteEntity: () => deletePaymentDestinationProps.deleteEntity(payoutDestination.uuid, payoutDestination.type),
          resetDelete: deletePaymentDestinationProps.resetDelete,
        },
      }))
    : [];
};

export const isKycApprovedStatus = (status?: MerchantKycStatuses): boolean => {
  return status !== undefined && ALLOWED_KYC_STATUSES.includes(status);
};
